(function () {
  function formatMoney(cents) {
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function getCartProductIds(cart) {
    var ids = [];
    cart.items.forEach(function (item) {
      if (ids.indexOf(item.product_id) === -1) ids.push(item.product_id);
    });
    return ids;
  }

  function pickRecommendation(recommendations, excludeIds) {
    for (var i = 0; i < recommendations.length; i++) {
      if (excludeIds.indexOf(recommendations[i].id) === -1) {
        return recommendations[i];
      }
    }
    return null;
  }

  function renderCard(container, product) {
    var variants = product.variants || [];
    var firstAvailable = variants.find(function (v) { return v.available; }) || variants[0];
    if (!firstAvailable) {
      container.innerHTML = '';
      return;
    }

    var optionsHtml = variants
      .map(function (v) {
        return '<option value="' + v.id + '"' + (v.available ? '' : ' disabled') + (v.id === firstAvailable.id ? ' selected' : '') + '>' +
          v.title + (v.available ? '' : ' (uitverkocht)') + '</option>';
      })
      .join('');

    var priceHtml = '<span class="cross-sell-card__price-current">' + formatMoney(firstAvailable.price) + '</span>';
    if (firstAvailable.compare_at_price && firstAvailable.compare_at_price > firstAvailable.price) {
      priceHtml = '<span class="cross-sell-card__price-compare">' + formatMoney(firstAvailable.compare_at_price) + '</span>' + priceHtml;
    }

    container.innerHTML =
      '<div class="cross-sell-card">' +
        '<img class="cross-sell-card__image" src="' + (product.featured_image || '') + '" alt="' + product.title.replace(/"/g, '&quot;') + '" loading="lazy">' +
        '<div class="cross-sell-card__body">' +
          '<p class="cross-sell-card__title">' + product.title + '</p>' +
          '<div class="cross-sell-card__price">' + priceHtml + '</div>' +
          (variants.length > 1
            ? '<select class="cross-sell-card__variant-select" data-cross-sell-variant>' + optionsHtml + '</select>'
            : '<input type="hidden" data-cross-sell-variant value="' + firstAvailable.id + '">') +
          '<button type="button" class="cross-sell-card__add-button" data-cross-sell-add>+ Toevoegen</button>' +
        '</div>' +
      '</div>';

    var addButton = container.querySelector('[data-cross-sell-add]');
    var variantEl = container.querySelector('[data-cross-sell-variant]');

    addButton.addEventListener('click', function () {
      var variantId = variantEl.value || variantEl.tagName === 'INPUT' ? variantEl.value : firstAvailable.id;
      addButton.disabled = true;
      addButton.textContent = 'Toevoegen…';

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
      })
        .then(function (res) { return res.json(); })
        .then(function () {
          addButton.textContent = 'Toegevoegd ✓';
          addButton.classList.add('cross-sell-card__added');
          window.location.reload();
        })
        .catch(function () {
          addButton.disabled = false;
          addButton.textContent = '+ Toevoegen';
        });
    });
  }

  var loadingMounts = new WeakSet();

  function loadCrossSellFor(mount) {
    var body = mount.querySelector('[data-cross-sell-body]');
    var firstProductId = mount.getAttribute('data-first-product-id');
    if (!firstProductId || !body) return;

    // Avoid kicking off a duplicate fetch for a mount that's already loading
    // (the DOM observer below can otherwise fire multiple times in quick
    // succession while the cart drawer re-renders).
    if (loadingMounts.has(mount)) return;
    loadingMounts.add(mount);

    fetch(window.Shopify.routes.root + 'cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        if (cart.item_count === 0) return null;
        var excludeIds = getCartProductIds(cart);
        return fetch(
          window.Shopify.routes.root + 'recommendations/products.json?product_id=' + firstProductId + '&limit=6&intent=related'
        )
          .then(function (res) { return res.json(); })
          .then(function (data) {
            var rec = pickRecommendation(data.products || [], excludeIds);
            if (!rec) {
              mount.style.display = 'none';
              return;
            }
            return fetch(window.Shopify.routes.root + 'products/' + rec.handle + '.js')
              .then(function (res) { return res.json(); })
              .then(function (fullProduct) {
                renderCard(body, fullProduct);
              });
          });
      })
      .catch(function () {
        mount.style.display = 'none';
      })
      .finally(function () {
        loadingMounts.delete(mount);
      });
  }

  function loadCrossSell() {
    var mounts = document.querySelectorAll('[data-cross-sell-mount]');
    mounts.forEach(function (mount) {
      loadCrossSellFor(mount);
    });
  }

  document.addEventListener('DOMContentLoaded', loadCrossSell);
  document.addEventListener('cart:refresh', loadCrossSell);

  var cartDrawerEl = document.querySelector('cart-drawer');
  if (cartDrawerEl) {
    var activeObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.attributeName === 'class' && cartDrawerEl.classList.contains('active')) {
          loadCrossSell();
        }
      });
    });
    activeObserver.observe(cartDrawerEl, { attributes: true });
  }

  // Dawn re-renders the cart drawer (and the cart page footer) by swapping
  // in fresh server HTML whenever a line item quantity changes or a line is
  // removed — see cart.js `onCartUpdate` / `updateQuantity`. That fresh HTML
  // always starts with the "Aanbevelingen laden…" placeholder, but nothing
  // else re-triggers our fetch afterwards (no `cart:refresh` event is
  // dispatched, and the drawer's own open/close class doesn't change while
  // it's already open). Watch the document for any cross-sell mount node
  // being (re)inserted and load it as soon as it appears, so the section
  // never gets stuck on the loading state after the cart changes.
  var reinsertObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches('[data-cross-sell-mount]')) {
          loadCrossSellFor(node);
        }
        if (node.querySelectorAll) {
          node.querySelectorAll('[data-cross-sell-mount]').forEach(function (mount) {
            loadCrossSellFor(mount);
          });
        }
      });
    });
  });
  reinsertObserver.observe(document.body, { childList: true, subtree: true });
})();
